import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    
  }

}



// WEBPACK FOOTER //
// /home/lynkit/Downloads/staging-boltseal/boltseal/newsletter-client/src/app/navbar/navbar.component.ts